import IconConnectors from '@apollo/icons/default/IconConnectors.svg';
import IconSingleService from '@apollo/icons/small/IconSingleService.svg';
import IconSingleServiceDeferred from '@apollo/icons/small/IconSingleServiceDeferred.svg';
import {
  Link,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from '@apollo/orbit';
import React from 'react';

import { TraceTreeNode } from '../TraceTree';

const SUBGRAPH_PREFIX = 'subgraph:';

export const TraceNodeName = ({ node }: { node: TraceTreeNode }) => {
  let nodeDisplayName = `${node.name}`;
  if (node.isRootNode && nodeDisplayName.trim() === '') {
    nodeDisplayName = '(unspecified operation name)';
  } else if (
    node.isFetch &&
    typeof node.name === 'string' &&
    node.name.startsWith(SUBGRAPH_PREFIX)
  ) {
    nodeDisplayName = node.name.substring(SUBGRAPH_PREFIX.length);
  }

  return (
    <>
      {node.isFetch ? (
        <>
          {node.isDeferredFetch ? (
            <Popover trigger="hover" variant="tooltip">
              <PopoverTrigger>
                <IconSingleServiceDeferred className="h-[0.8rem] w-[1.3rem] text-placeholder" />
              </PopoverTrigger>
              <Portal>
                <PopoverContent>
                  <PopoverBody>
                    <p>
                      This subgraph fetch was deferred.{' '}
                      <Link
                        isExternal
                        to="https://www.apollographql.com/docs/router/executing-operations/defer-support/"
                      >
                        Visit the docs
                      </Link>{' '}
                      to learn more about the{' '}
                      <span className="font-mono">@defer</span> directive.
                    </p>
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </Popover>
          ) : node.isConnector ? (
            <IconConnectors className="text-icon-primary" />
          ) : (
            <IconSingleService className="text-icon-primary" />
          )}
          <span className="ml-1 truncate py-1">{nodeDisplayName}</span>
        </>
      ) : (
        <span className="truncate py-1">
          {nodeDisplayName}
          {node.type && `: ${node.type}`}
        </span>
      )}
    </>
  );
};
